import { Dispatch, FC, SetStateAction, useEffect, useRef } from 'react'
import {
  CSSObject,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  // ListSubheader,
  makeStyles,
  styled,
  Theme,
  Toolbar,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@perk-ui/core'
import clsx from 'clsx'
import {
  ChevronsLeft,
  ChevronsRight,
  Database,
  FileText,
  Layout,
  Loader,
  Lock,
  LogOut,
  Share2,
  User,
} from 'react-feather'
import { useHistory, useLocation } from 'react-router'

import { pathsWithoutSidebar } from '../config/constants'
import { useAuth, useUser } from '../features/auth/AuthContext'
// import AppLinkButton from './AppLinkButton'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.paper,
  },
  toolbarGap: theme.mixins.toolbar,
  linkContainer: {
    background: theme.palette.background.paper,
    marginTop: theme.spacing(1),
    width: '100%',
    height: '100%',
    maxWidth: 270,
    padding: theme.spacing(0, 0, 2, 0),
    '& .MuiListSubheader-root': {
      fontSize: '20px',
      fontWeight: 500,
      color: theme.palette.common.black,
    },
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  link: {
    margin: theme.spacing(0.5, 0),
    padding: theme.spacing(1.7, 1.5),
    borderRadius: 8,
    '&:hover': {
      background: 'rgba(87, 153, 173, 0.04)',
    },
    '& .ListItemText': {
      margin: 0,
    },
    '& .MuiListItemIcon-root': {
      height: 30,
    },
    '& h5': {
      fontSize: 16,
      fontWeight: 400,
    },
    '& svg': {
      margin: 'auto',
    },
    '& span': {
      margin: 'auto',
    },
  },
  fancyButton: {
    '&:hover': {
      // background: theme.palette.primary.light,
    },
  },
  active: {
    // css specificity hack to override `a:link`
    '&&': {
      color: theme.palette.primary.main,
    },
    background: 'rgba(87, 153, 173, 0.04)',
  },
  activeStudy: {
    '&&': {
      color: theme.palette.common.black,
      '& h5': {
        fontWeight: 600,
      },
    },
  },
  subHeader: {
    margin: theme.spacing(0, 1, 2, 1),
    padding: 0,
  },
  subMenu: {},
  subMenuHeader1: {
    margin: theme.spacing(0, 2),
    padding: 0,
    borderBottom: '1px solid ',
    fontSize: '20px',
    fontWeight: 400,
    color: theme.palette.common.black,
  },
  subMenuHeader2: {
    paddingTop: theme.spacing(2),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  subMenuLink: {
    margin: theme.spacing(0.5, 0),
    padding: theme.spacing(1, 1.5),
    '&:hover': {
      background: 'rgba(87, 153, 173, 0.04)',
    },
    '& .ListItemText': {
      margin: 0,
      position: 'relative',
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        left: 0,
        top: 0,
        borderRadius: '8px',
        width: '4px',
        height: '100%',
      },
    },
    '& svg': {
      margin: 'auto',
    },
    '& h5': {
      fontSize: 16,
      fontWeight: 500,
      paddingLeft: theme.spacing(1),
    },
  },
  disabledLink: {
    color: '#919191 !important',
    cursor: 'not-allowed',
    '& .ListItemText': {
      '&::before': {
        backgroundColor: '#919191',
      },
    },
    '& svg': {
      color: '#919191 !important',
    },
  },
  disabledTooltip: {
    '& .MuiTooltip-tooltip': {
      maxWidth: '250px',
    },
  },
  drawerHeader: {
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
  },
  drawerContainer: {
    '& .MuiDrawer-paper': {
      borderRight: 'none',
      paddingLeft: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
    },
  },
  mobileFooter: {
    marginTop: 'auto',
    borderTop: '1px solid #F1F1F1',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  menuLinkIcon: {
    margin: 'auto',
    minWidth: 'unset',
    '& svg': {
      margin: 'auto',
    },
  },
  smallFancyButton: {
    minWidth: 'unset',
    '& .MuiButton-startIcon': {
      margin: 0,
      padding: theme.spacing(0.3),
    },
  },
  // Collapse button Menu
  collapseButtonList: {
    marginTop: theme.spacing(2),
    '& .collapse-button-list-item': {
      '& .ListItemText': {
        marginLeft: theme.spacing(1),
        width: 'auto',
        '& h5': {
          color: '#545454',
          fontSize: '16px',
          fontWeight: '400',
        },
      },
    },
  },
  collapseMenuLinkIcon: {
    margin: 'auto',
    minWidth: 'unset',
    '& svg': {
      margin: 'auto',
    },
  },
  menuExpandButton: {
    margin: 'unset',
    marginLeft: 'auto',
  },
  // Studies Links
  studiesLinkContainer: {
    background: theme.palette.background.paper,
    width: '100%',
    maxWidth: 270,
    '& .MuiListItemIcon-root': {
      height: '50px',
    },
    '& .ListItemText': {
      overflow: 'hidden',
    },
    '& .MuiTypography-body1': {
      color: theme.palette.common.black,
    },
    '& .MuiTypography-body2': {
      color: theme.palette.common.black,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  tooltipClass: {
    '& MuiTooltip-tooltip': {
      borderRadius: '7px',
    },
  },
  noVisible: {
    visibility: 'hidden',
  },
}))

export interface AppSidebarProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  drawerWidth: number
}

const AppSidebar: FC<AppSidebarProps> = ({ open, setOpen, drawerWidth }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const currentUser = useUser()
  const { signOut } = useAuth()
  const accessUserTableauSubscription =
    currentUser?.accessUser?.sponsor?.subscriptionPlan || ''
  const isPremiumSubscription = accessUserTableauSubscription === 'premium'
  const { pathname } = useLocation()
  const isCurrentLocation = (path: string) => pathname.startsWith(path)

  const myRef = useRef<HTMLDivElement>(null)

  const { push } = useHistory()

  const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  })

  const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(10)} + 1px)`,
    },
  })

  const MuiDrawer = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    width: drawerWidth,

    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }))

  const handleDraweClick = () => {
    setOpen(!open)
  }

  const navigate = (path: string) => {
    if (isMobile) setOpen(false)
    push({ pathname: path, state: { from: location.pathname } })
  }

  useEffect(() => {
    if (isCurrentLocation('/quick-stats') && open) {
      setOpen(false)
    }
  }, [pathname])

  if (pathsWithoutSidebar.some(isCurrentLocation)) return null

  const navContent = (
    <>
      <Toolbar className={classes.drawerHeader} />
      <List className={classes.linkContainer} component="nav">
        <Tooltip
          className={classes.tooltipClass}
          placement="right"
          arrow
          title={open ? '' : 'My Access'}
        >
          <ListItemButton
            onClick={() =>
              isCurrentLocation('/my-access')
                ? undefined
                : navigate('/my-access')
            }
            className={clsx(classes.link, {
              [classes.active]: isCurrentLocation('/my-access'),
            })}
          >
            <ListItemIcon className={open ? '' : classes.menuLinkIcon}>
              <Layout
                className={
                  isCurrentLocation('/my-access') ? classes.active : ''
                }
                size={20}
              />
            </ListItemIcon>
            {open && <ListItemText title={'My Access'} />}
          </ListItemButton>
        </Tooltip>
        <Tooltip
          arrow
          title={
            isPremiumSubscription
              ? ''
              : 'To unlock this feature, please contact your DataBiologics representative to upgrade your account'
          }
          classes={{ popper: classes.disabledTooltip }}
        >
          <ListItemButton
            id="sidebar-quick-stats-link"
            onClick={() =>
              isPremiumSubscription
                ? isCurrentLocation('/quick-stats')
                  ? undefined
                  : navigate('/quick-stats')
                : undefined
            }
            className={clsx(
              classes.link,
              isCurrentLocation('/quick-stats') && classes.active,
              {
                [classes.disabledLink]: !isPremiumSubscription,
              },
            )}
          >
            <ListItemIcon className={open ? '' : classes.menuLinkIcon}>
              <Tooltip arrow title={open ? '' : 'Quick Stats'}>
                {isPremiumSubscription ? (
                  <Loader
                    className={
                      isCurrentLocation('/quick-stats') ? classes.active : ''
                    }
                  />
                ) : (
                  <Lock
                    className={
                      isCurrentLocation('/quick-stats') ? classes.active : ''
                    }
                  />
                )}
              </Tooltip>
            </ListItemIcon>
            {open && <ListItemText title={'Quick Stats'} />}
          </ListItemButton>
        </Tooltip>
        <Tooltip
          className={classes.tooltipClass}
          placement="right"
          arrow
          title={open ? '' : 'My Teams'}
        >
          <ListItemButton
            onClick={() =>
              isCurrentLocation('/my-teams') ? undefined : navigate('/my-teams')
            }
            className={clsx(classes.link, {
              [classes.active]: isCurrentLocation('/my-teams'),
            })}
          >
            <ListItemIcon className={open ? '' : classes.menuLinkIcon}>
              <Share2
                className={isCurrentLocation('/my-teams') ? classes.active : ''}
                size={20}
              />
            </ListItemIcon>
            {open && <ListItemText title={'My Teams'} />}
          </ListItemButton>
        </Tooltip>
        <Tooltip
          className={classes.tooltipClass}
          placement="right"
          arrow
          title={open ? '' : 'My Studies'}
        >
          <ListItemButton
            onClick={() =>
              isCurrentLocation('/my-studies')
                ? undefined
                : navigate('/my-studies')
            }
            className={clsx(classes.link, {
              [classes.active]: isCurrentLocation('/my-studies'),
            })}
          >
            <ListItemIcon className={open ? '' : classes.menuLinkIcon}>
              <FileText
                className={
                  isCurrentLocation('/my-studies') ? classes.active : ''
                }
                size={20}
              />
            </ListItemIcon>
            {open && <ListItemText title={'My Studies'} />}
          </ListItemButton>
        </Tooltip>
        <Tooltip
          className={classes.tooltipClass}
          placement="right"
          arrow
          title={open ? '' : 'Raw Data'}
        >
          <ListItemButton
            onClick={() =>
              isCurrentLocation('/raw-data') ? undefined : navigate('/raw-data')
            }
            className={clsx(classes.link, {
              [classes.active]: isCurrentLocation('/raw-data'),
            })}
          >
            <ListItemIcon className={open ? '' : classes.menuLinkIcon}>
              <Database
                className={isCurrentLocation('/raw-data') ? classes.active : ''}
                size={20}
              />
            </ListItemIcon>
            {open && <ListItemText title={'Raw Data'} />}
          </ListItemButton>
        </Tooltip>
      </List>
      {!isMobile && (
        <List>
          <Tooltip arrow title={open ? 'Collapse Menu' : 'Expand Menu'}>
            <ListItemButton
              onClick={handleDraweClick}
              className={clsx(classes.link)}
            >
              <ListItemIcon
                className={clsx(classes.menuLinkIcon, {
                  [classes.menuExpandButton]: open,
                })}
              >
                {open ? <ChevronsLeft /> : <ChevronsRight />}
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>
        </List>
      )}
      {isMobile && (
        <List className={classes.mobileFooter}>
          <ListItemButton className={classes.link}>
            <ListItemIcon>
              <User size={20} />
            </ListItemIcon>
            <ListItemText
              title={currentUser?.accessUser.firstName ?? 'Profile'}
            />
          </ListItemButton>
          <ListItemButton
            onClick={() => {
              setOpen(false)
              signOut()
            }}
            className={classes.link}
          >
            <ListItemIcon>
              <LogOut size={20} />
            </ListItemIcon>
            <ListItemText title="Sign Out" />
          </ListItemButton>
        </List>
      )}
    </>
  )

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={open}
        onClose={() => setOpen(false)}
        className={classes.drawerContainer}
        PaperProps={{ sx: { width: drawerWidth } }}
        ModalProps={{ keepMounted: true }}
      >
        {navContent}
      </Drawer>
    )
  }

  return (
    <>
      <div ref={myRef} />
      <MuiDrawer
        variant="permanent"
        open={open}
        className={classes.drawerContainer}
        hideBackdrop
      >
        {navContent}
      </MuiDrawer>
    </>
  )
}

export default AppSidebar
